import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@hl/ui-components';
import React from 'react';
import './WebsiteAlert.scss';

interface WebsiteAlertProps {
    alertClass: string;
    linkText: string;
    linkUrl: string;
    text: string;
    showLink: boolean;
    visible: boolean;
}

const WebsiteAlert: React.FCC<WebsiteAlertProps> = ({ alertClass, linkText, linkUrl, text, showLink, visible }) => {
    return visible ? (
        <div className={`bootstrap-4 website-alert-container ${alertClass}`} qa-id="websiteAlert">
            <div className="container p-1">
                <div className="col-md-12">
                    <Icon icon={faExclamationTriangle} className="mr-2" />
                    &nbsp; {text} {showLink ? <a href={linkUrl}>{linkText}</a> : null}
                </div>
            </div>
        </div>
    ) : null;
};

export default React.memo(WebsiteAlert);
